import { alpha, type Components, type Theme } from '@mui/material/styles'

import { borderRadius, fontSize, spacing } from '@/themes/tokens'

/**
 * A segmented control: a small set of mutually exclusive choices, all visible.
 *
 * Styled to sit alongside the outlined controls rather than read as a row of
 * buttons — the selected segment is filled in the brand blue and the rest stay
 * quiet, so the current choice is legible without opening anything.
 */
export const MuiToggleButtonGroupOverride: Components<Theme>['MuiToggleButtonGroup'] = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: borderRadius.control,
      backgroundColor: theme.palette.background.paper,
    }),
  },
}

export const MuiToggleButtonOverride: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: borderRadius.control,
      textTransform: 'none',
      fontSize: fontSize.base,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      paddingTop: theme.spacing(spacing.xs),
      paddingBottom: theme.spacing(spacing.xs),
      paddingLeft: theme.spacing(spacing.md),
      paddingRight: theme.spacing(spacing.md),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.04),
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    }),
  },
}
